<template>
  <div class="left_nav">
    <el-menu
      :default-active="defaultActiveMenuIndex"
      :collapse="isCollapse"
      class="el-menu-vertical-demo">
      <el-menu-item index="1" @click="toNewRouter('customer-master-data')" v-if="permissionCodes.indexOf('041001000') !== -1">
        <i class="el-icon-damai-ic_kehuzhushuju"></i>
        <span slot="title">客户主数据</span>
      </el-menu-item>
      <el-menu-item index="2" @click="toNewRouter('basic-information')" v-if="permissionCodes.indexOf('041002000') !== -1">
        <i class="el-icon-damai-ic_jichuxinxi"></i>
        <span slot="title">基础信息</span>
      </el-menu-item>
      <el-menu-item index="3" @click="toNewRouter('cost-center')" v-if="permissionCodes.indexOf('041003000') !== -1">
        <i class="el-icon-damai-ic_lirunchengbenzhongxin"></i>
        <span slot="title">利润/成本中心</span>
      </el-menu-item>
      <el-menu-item index="4" @click="toNewRouter('scenario-template')" v-if="permissionCodes.indexOf('041004000') !== -1">
        <i class="el-icon-damai-ic_changjingmoban"></i>
        <span slot="title">场景模板</span>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
import navMixin from "../../utils/nav";
import { bus } from "../../utils/bus";

const indexOfRouterNameEntities = Object.entries({
  1: ["customer-master-data"],
  2: ["basic-information", "basic-information-add", "basic-information-modify"],
  3: ["cost-center", "cost-center-add", "cost-center-modify"],
  4: ["scenario-template", "scenario-template-add", "scenario-template-modify"]
});

export default {
  name: "data-sync-nav",
  mixins: [navMixin],
  computed: {
    defaultActiveMenuIndex() {
      const { name: routeName } = this.$route;
      const entity = indexOfRouterNameEntities.find(([, routeNames]) => {
        if (routeNames instanceof Array) {
          return routeNames.indexOf(routeName) >= 0;
        } else {
          return routeNames === routeName;
        }
      });
      return entity && entity[0];
    }
  },
  data() {
    return {
      isCollapse: false,
      permissionCodes: "",
      indexOfRouterNameEntities
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
  },
  mounted() {
    bus.vue.$on("changeIsCollapse", data => {
      this.isCollapse = data;
    });
  },
  methods: {
    toNewRouter(name) {
      this.$router.push({
        name: name
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../components/CommonStyle/commonNavStyle";
</style>



// WEBPACK FOOTER //
// src/view/DataSync/DataSyncNav.vue